import { FunctionComponent } from 'react';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import { TextBox } from 'components/common/TextBox';
import { Label } from 'components/common/Label';
import addFormats from 'ajv-formats'
import ajvErrors from 'ajv-errors';
import Ajv from "ajv";
import useFeedbacks, {FeedbackState} from "model/feedback/FeedbackStore"
import { validate } from "model/feedback/FeedbackValidation";

const ajv = new Ajv({ allErrors: true, $data: true, strict: false });
addFormats(ajv);
ajvErrors(ajv);

export const FeedbackFormComponent: FunctionComponent = () => {

  const formData = useFeedbacks((state: FeedbackState) => state.feedback);
  const updateFeedback = useFeedbacks((state: FeedbackState) => state.updateFeedback);

  const violations = useFeedbacks((state) => state.violations);
  const updateViolations = useFeedbacks((state: FeedbackState) => state.updateViolations);

  const visited = useFeedbacks((state) => state.visited);

  const handleChange = (event: any) => {
    if (!event.target)
      return;

    const { name, value } = event.target;
    updateFeedback(name, value);
    visited.add(`/${name}`);
    updateViolations(validate({ ...formData, [name]: value }, visited));
  };
  
  const handleBlur = (el: any) => {
    visited.add(`/${el.target.name}`);
    let errors = validate(formData, visited);

    updateViolations(errors);
  }

  return (
    <Box component="form" noValidate autoComplete="off">
        <TextBox
          name="senderEmail"
          label="Email"
          value={formData.senderEmail}
          onChange={handleChange}
          onBlur={handleBlur}
          error={violations?.get("senderEmail")}
          helpText="Email address" />

        <TextBox
          name="senderName"
          label="Name"
          value={formData.senderName}
          onBlur={handleBlur}
          onChange={handleChange}
          error={violations?.get("senderName")}
          helpText="The email title" />          
          
        <Label label="Message"/>
        <TextField required
                    sx={violations?.get("message")?
                      { mx: 0, mt: "2px", mb: "8px" }:
                      { mx: 0, mt: "2px", mb: "31px" }
                    }
                    fullWidth
                    name="message"
                    onBlur={handleBlur}
                    multiline
                    value={formData.message}
                    error={violations?.get("message")?true:false}
                    minRows={4}
                    helperText={violations?.get("message")}
                    onChange={handleChange} />
    </Box>
  );
}
export default FeedbackFormComponent;